import React from 'react';
import Switcher from '../ui/switcher/Switcher';
import _ from 'lodash';
import BzmIcon from '../icons/BzmIcon';
import { MockService, PriorityMode } from '../../types/rest/mockServiceTypes';
import { MockServiceTemplate } from '../../store/mockServiceTemplates/mockServiceTemplateTypes';

interface PrioritySwitcherProps {
  onPriorityModeChanged: (priority: PriorityMode) => void;
  priorityMode: PriorityMode;
  context: MockService | MockServiceTemplate;
  onUpdatePriorityModal: (isShown: boolean) => void;
  disabled?: boolean;
}

const PrioritySwitcher = (props: PrioritySwitcherProps) => {
  const { onPriorityModeChanged, priorityMode } = props;
  const isUniquePriority = !_.isNil(priorityMode) && priorityMode === 'UNIQUE_PRIORITY';

  const customizePriorityEl = (
    <a role="button" className={'btn-link pr-1'}>
      <BzmIcon variant={'icon-bzm-edit ml-1'} /> Customize
    </a>
  );

  const onPriorityModeChangedHandler = () => {
    const priority =
      priorityMode === PriorityMode.default || _.isNil(priorityMode)
        ? PriorityMode.unique_priority
        : PriorityMode.default;
    onPriorityModeChanged(priority);
  };

  return (
    <>
      <div className={'float-right'}>
        <div className={'d-inline-block'}>
          <Switcher
            disabled={props.disabled}
            label={'Unique Priorities'}
            size={'md'}
            onChange={onPriorityModeChangedHandler}
            checked={isUniquePriority}
          />
        </div>
        {isUniquePriority && (
          <div
            className={'d-inline-block ml-3'}
            onClick={() => {
              props.onUpdatePriorityModal(true);
            }}
          >
            ({customizePriorityEl})
          </div>
        )}
      </div>
    </>
  );
};

export default PrioritySwitcher;
